
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ivpO0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d78f23b30876736b$export$2e2bcd8739ae039);

var $kFqI2 = parcelRequire("kFqI2");

function $bdaa45c065fd6fd6$export$220bda22c3bcb06f(options) {
    return {
        type: 'REMOVE_ERROR',
        ...options
    };
}
function $bdaa45c065fd6fd6$export$a7fa4e6497c6274e() {
    return {
        type: 'CONNECTION_ONLINE'
    };
}
function $bdaa45c065fd6fd6$export$fb68e1df1c89cc59() {
    return {
        type: 'CONNECTION_OFFLINE'
    };
}



var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $fU6PL = parcelRequire("fU6PL");

function $6a3f9444e79d609a$export$a56241c767c1d89f() {
    if (typeof window !== 'undefined') return navigator;
}





var $6xSfH = parcelRequire("6xSfH");



class $7a5ded9fb0140cac$var$ErrorHandlerComponent extends (0, $42omo.Component) {
    componentWillUnmount() {
        (0, $fU6PL.removeEventListener)('online', this.handleConnectionIssues);
        (0, $fU6PL.removeEventListener)('offline', this.handleConnectionIssues);
    }
    handleConnectionIssues() {
        const type = (0, $6a3f9444e79d609a$export$a56241c767c1d89f)().onLine ? 'success' : 'error';
        if (type === 'success') this.props.connectionOnline();
        else this.props.connectionOffline();
    }
    render() {
        const { error: error, intl: intl, ...otherProps } = this.props;
        const { title: title, body: body, bodyKey: bodyKey, close: close } = error;
        let i18nTitle, flagBody;
        if (error.error) {
            const titleMessage = {
                id: title,
                // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
                // eslint-disable-next-line no-restricted-syntax
                defaultMessage: "Something's gone wrong."
            };
            i18nTitle = intl.formatMessage(titleMessage);
            const bodyKeyMessage = {
                id: bodyKey,
                defaultMessage: 'Try again later.'
            };
            const i18nBodyKey = intl.formatMessage(bodyKeyMessage);
            flagBody = body ? body.replace('i18nPlaceholder', i18nBodyKey) : i18nBodyKey;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xSfH.default), {
            isShowing: error.error,
            type: error.type,
            title: i18nTitle,
            body: flagBody,
            close: close,
            ...otherProps
        });
    }
    constructor(props){
        super(props);
        this.handleConnectionIssues = this.handleConnectionIssues.bind(this);
        (0, $fU6PL.addEventListener)('online', this.handleConnectionIssues);
        (0, $fU6PL.addEventListener)('offline', this.handleConnectionIssues);
    }
}
$7a5ded9fb0140cac$var$ErrorHandlerComponent.propTypes = {
    /**
   * The error object from state
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * The intl object containing the i18n strings
   */ intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Dispatch function to hide errors
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    /**
   * Dispatch function to trigger a connection online action
   */ connectionOnline: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    /**
   * Dispatch function to trigger a connection offline action
   */ connectionOffline: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
var $7a5ded9fb0140cac$export$2e2bcd8739ae039 = (0, $gmMgo.default)($7a5ded9fb0140cac$var$ErrorHandlerComponent);


function $d78f23b30876736b$var$mapStateToProps(state) {
    return {
        error: state.session.errors
    };
}
var $d78f23b30876736b$export$2e2bcd8739ae039 = (0, $kFqI2.connect)($d78f23b30876736b$var$mapStateToProps, {
    onClose: $bdaa45c065fd6fd6$export$220bda22c3bcb06f,
    connectionOnline: $bdaa45c065fd6fd6$export$a7fa4e6497c6274e,
    connectionOffline: $bdaa45c065fd6fd6$export$fb68e1df1c89cc59
})((0, $7a5ded9fb0140cac$export$2e2bcd8739ae039));

});

parcelRegister("fU6PL", function(module, exports) {
/* istanbul ignore next */ function $b941630dfdd9456a$export$89e12c5b50f7529d(url) {
    window.location = url;
}
function $b941630dfdd9456a$export$17b07c660794dc13() {
    if (typeof window !== 'undefined') return window.location;
    else return undefined;
}
function $b941630dfdd9456a$export$f710a83a91838a36() {
    if (typeof window === 'undefined' || !window.location) return undefined;
    let origin = window.location.origin;
    if (!origin) origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
    return origin;
}
function $b941630dfdd9456a$export$32da5b5043dcd88c() {
    if (typeof window !== 'undefined') window.location.reload();
}
function $b941630dfdd9456a$export$715f9d76bb8c1fea(message) {
    if (typeof window === 'undefined') return true;
    return window.confirm(message);
}
function $b941630dfdd9456a$export$3f65cefe8380dbea(...args) {
    if (typeof window !== 'undefined') window.addEventListener.apply(window, args);
}
function $b941630dfdd9456a$export$8ff9f68337b520c0(...args) {
    if (typeof window !== 'undefined') window.removeEventListener.apply(window, args);
}
function $b941630dfdd9456a$export$3ef1368fc1aa92de(element) {
    if (typeof window === 'undefined') return element.offsetHeight;
    const style = window.getComputedStyle(element);
    const height = element.offsetHeight;
    return height + parseInt(style.marginTop) + parseInt(style.marginBottom);
}
function $b941630dfdd9456a$export$5a2da8cd883b1f88(element) {
    if (typeof window === 'undefined') return element.offsetHeight;
    const style = window.getComputedStyle(element);
    const height = element.offsetHeight;
    return height - parseInt(style.paddingTop) - parseInt(style.paddingBottom) - parseInt(style.borderTopWidth) - parseInt(style.borderBottomWidth);
}
function $b941630dfdd9456a$export$18e9b0709c75d4c5(element) {
    if (typeof window === 'undefined') return element.offsetWidth;
    const style = window.getComputedStyle(element);
    const width = element.offsetWidth;
    return width + parseInt(style.marginLeft) + parseInt(style.marginRight);
}
function $b941630dfdd9456a$export$fd39c00f94741b03() {
    if (typeof window === 'undefined') return 0;
    return window.pageYOffset;
}
function $b941630dfdd9456a$export$d23fbaf1a2e7133c() {
    if (typeof window === 'undefined') return 0;
    return window.innerWidth;
}
function $b941630dfdd9456a$export$d3ad305c42af1069() {
    if (typeof window === 'undefined') return 0;
    return window.innerHeight;
}
function $b941630dfdd9456a$export$6cb2c4c0a22909c0() {
    const window1 = window1 || {};
    const polyfill = (callback)=>{
        setTimeout(callback, 1000 / 60);
    };
    return window1.requestAnimationFrame || polyfill;
}
function $b941630dfdd9456a$export$139d5ccee31f82f4(...args) {
    if (!window) return;
    if (!window.require) return;
    return window.require.apply(window, args);
}
function $b941630dfdd9456a$export$f9582a3c130d9538() {
    if (typeof window === 'undefined') return 0;
    return window.history;
}
function $b941630dfdd9456a$export$38b2d434cce3ea22() {
    return window;
}
module.exports["reload"] = $b941630dfdd9456a$export$32da5b5043dcd88c;
module.exports["confirm"] = $b941630dfdd9456a$export$715f9d76bb8c1fea;
module.exports["addEventListener"] = $b941630dfdd9456a$export$3f65cefe8380dbea;
module.exports["removeEventListener"] = $b941630dfdd9456a$export$8ff9f68337b520c0;
module.exports["globalRequire"] = $b941630dfdd9456a$export$139d5ccee31f82f4;
module.exports["getWindow"] = $b941630dfdd9456a$export$38b2d434cce3ea22;

});

parcelRegister("6xSfH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $a4TK8 = parcelRequire("a4TK8");


var $fU6PL = parcelRequire("fU6PL");


var $cpjd2 = parcelRequire("cpjd2");

/* istanbul ignore next */ const $4c3fe885b74e61f4$var$noop = ()=>{};
class $4c3fe885b74e61f4$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    componentDidMount() {
        this._createFlag(this.props);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.props, nextProps);
    }
    componentDidUpdate() {
        this._closeFlag(null, true);
        this._createFlag(this.props, true);
    }
    componentWillUnmount() {
        this._closeFlag();
    }
    _createFlag(props, isUpdateFlag) {
        const { isShowing: isShowing, type: type, title: title, body: body, close: close, extraClasses: extraClasses, ...otherProps } = props;
        if (!isShowing) return null;
        (0, $cpjd2.requireLegacyWRM)([
            'wrc!confluence.aui.staging:confluence-flags'
        ], ()=>{
            const AUIFlag = (0, $fU6PL.globalRequire)('confluence/flag');
            // a new flagEl can be created when props are updated.
            // so we need to close the old one and show the new one.
            this.flagEl && this._closeFlag(null, isUpdateFlag);
            try {
                this.flagEl = AUIFlag({
                    type: type,
                    title: title,
                    body: body,
                    close: close,
                    extraClasses: extraClasses,
                    ...otherProps
                });
                this.flagEl.addEventListener('aui-flag-close', this._closeFlag);
                if (this.props.onShow) this.props.onShow(this.flagEl);
            } catch (error) {
                console.error(error);
            }
        }, ()=>{});
        return null;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this._closeFlag = (event, isUpdateFlag)=>{
            if (this.flagEl) {
                this.flagEl.removeEventListener('aui-flag-close', this._closeFlag);
                // `this.flagEl.close` will trigger `aui-flag-close` event so this line should be after above removing listener event.
                this.flagEl.close();
                if (this.props.onClose) this.props.onClose(isUpdateFlag);
                this.flagEl = undefined;
            }
        };
    }
}
$4c3fe885b74e61f4$export$2e2bcd8739ae039.propTypes = {
    /**
   * Whether to show an error flag or not
   */ isShowing: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * What type of flag to show
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'success',
        'info',
        'warning',
        'error'
    ]),
    /**
   * The title to use in the flag
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * The body of the flag
   */ body: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
   * How the flag should be closed, either auto, manual or never
   */ close: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'manual',
        'auto',
        'never'
    ]),
    /**
   * A callback function which is called when flag closes
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    /**
   * A callback function which is called when flag shows.
   * The callback will be passed a DOM element of flag which is created by AUIFlag function.
   */ onShow: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    /**
   * Extra classname
   */ extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
$4c3fe885b74e61f4$export$2e2bcd8739ae039.defaultProps = {
    onShow: $4c3fe885b74e61f4$var$noop,
    onClose: $4c3fe885b74e61f4$var$noop
};
module.exports["default"] = $4c3fe885b74e61f4$export$2e2bcd8739ae039;

});


//# sourceMappingURL=error-container.465e6a0b.js.map
